import React from 'react';
import { Drawer } from '@gjensidige/core-drawer';
import { text } from '../../../utils/text';
import { Text, Title } from '@gjensidige/core-typography';
import style from './automatiske-prosesser-modal.module.less';
export const AutomatiskeProsesserModal = ({ visible, onClose }) => {
    return (React.createElement(Drawer, { closable: true, visible: visible, onClick: onClose, ariaLabel: text.AUTOMATISERTE_PROSESSER_MODAL.ARIA_LABEL.no, ariaLabelCloseButton: text.AUTOMATISERTE_PROSESSER_MODAL.ARIA_LABEL_CLOSE.no, className: style.modal, strict: false },
        React.createElement("section", null,
            React.createElement(Title, { tag: "h1", size: "h2" }, text.AUTOMATISERTE_PROSESSER_MODAL.TITLE.no),
            React.createElement(Text, { size: "lead" }, text.AUTOMATISERTE_PROSESSER_MODAL.SUBTITLE.no)),
        React.createElement("section", null,
            React.createElement(Title, { tag: "h2", size: "h4" }, text.AUTOMATISERTE_PROSESSER_MODAL.BUY_ONLINE.TITLE.no),
            React.createElement(Text, null, text.AUTOMATISERTE_PROSESSER_MODAL.BUY_ONLINE.CONTENT.no))));
};
